export function useFiltersCache() {
  const buildStorageKey = (key: string) => `${key}-params`;

  const getSearchParams = (key: string) => {
    const storageKey = buildStorageKey(key);
    const sessionRaw = sessionStorage.getItem(storageKey);

    if (sessionRaw !== null) {
      return JSON.parse(sessionRaw);
    }
    const localRaw = localStorage.getItem(storageKey);

    if (localRaw !== null) {
      sessionStorage.setItem(storageKey, localRaw);
      return JSON.parse(localRaw);
    }

    return {};
  };

  const setSearchParams = (key: string, params: Record<string, any>) => {
    const storageKey = buildStorageKey(key);
    const serialized = JSON.stringify(params);
    sessionStorage.setItem(storageKey, serialized);
    localStorage.setItem(storageKey, serialized);
  };

  return { getSearchParams, setSearchParams };
}
